/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SendMessageAttachment,
  SendMessageAttachment$Outbound,
  SendMessageAttachment$outboundSchema,
} from "./sendmessageattachment.js";

export type SendMessageRequestBody = {
  /**
   * The assistant to send the message to.
   */
  assistantId: string;
  /**
   * Files uploaded through assets.uploadChatAttachment that this turn carries.
   */
  attachments?: Array<SendMessageAttachment> | undefined;
  /**
   * The conversation to continue (from listChats or a prior sendMessage). Omit to start a new conversation; the server mints and returns a fresh chat id.
   */
  chatId?: string | undefined;
  /**
   * Stable key the client mints once per message so retries dedupe instead of enqueuing twice. A new key is generated server-side when omitted.
   */
  idempotencyKey?: string | undefined;
  /**
   * The user's message text. May be empty when the turn carries attachments.
   */
  message: string;
  /**
   * Project skills to make available for this turn.
   */
  skillIds?: Array<string> | undefined;
};

/** @internal */
export type SendMessageRequestBody$Outbound = {
  assistant_id: string;
  attachments?: Array<SendMessageAttachment$Outbound> | undefined;
  chat_id?: string | undefined;
  idempotency_key?: string | undefined;
  message: string;
  skill_ids?: Array<string> | undefined;
};

/** @internal */
export const SendMessageRequestBody$outboundSchema: z.ZodMiniType<
  SendMessageRequestBody$Outbound,
  SendMessageRequestBody
> = z.pipe(
  z.object({
    assistantId: z.string(),
    attachments: z.optional(z.array(SendMessageAttachment$outboundSchema)),
    chatId: z.optional(z.string()),
    idempotencyKey: z.optional(z.string()),
    message: z.string(),
    skillIds: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      assistantId: "assistant_id",
      chatId: "chat_id",
      idempotencyKey: "idempotency_key",
      skillIds: "skill_ids",
    });
  }),
);

export function sendMessageRequestBodyToJSON(
  sendMessageRequestBody: SendMessageRequestBody,
): string {
  return JSON.stringify(
    SendMessageRequestBody$outboundSchema.parse(sendMessageRequestBody),
  );
}
